export default __webpack_public_path__ + "static/media/radpad-bg.9f82889c.png";